<template>
    <div v-if="modelValue">
        <jet-select
            v-model="modelValue.type"
            :horizontal="false"
            :invalid-feedback="modelValue.errors.type"
            :label="trans('maintainers.overview.sla.asset_type.title')"
            :options="assetTypes"
            :required="true"
        >
            <template #selectedValue="{ selectedItem, placeholder }">
                <div class="flex flex-grow items-center justify-between gap-3">
                    <span>{{ selectedItem?.label || placeholder }}</span
                    ><small class="text-gray-500">{{ selectedItem?.shortLabel }}</small>
                </div>
            </template>
            <template #item-label="{ option }">
                <div class="flex items-center justify-between gap-3">
                    <span>{{ option.label }}</span
                    ><small class="text-gray-500 group-hover:!text-white group-[.text-white]:!text-white">{{ option.shortLabel }}</small>
                </div>
            </template>
        </jet-select>
        <jet-select
            v-model="modelValue.contractingAuthorityId"
            :horizontal="false"
            :invalid-feedback="modelValue.errors.contractingAuthorityId"
            :label="trans('maintainers.sla.contracting_authority.title')"
            :options="contractingAuthorities"
        />
    </div>
</template>

<script setup>
import JetSelect from '@/Jetstream/Select.vue';
import { trans } from '@/mixins/i18n';

defineProps({
    modelValue: Object,
    assetTypes: {
        type: Array,
        default: () => [],
    },
    contractingAuthorities: {
        type: Array,
        default: () => [],
    },
});
</script>
